define('shareCreateEditLayoutView',[
  'module',
  'marionette',
  'backbone',
  'jquery',
  'underscore',
  'app',
  'savingBehavior',
  'dialogFormView',
  'template!shareCreateEditLayoutTpl'
], function(
  module,
  Marionette,
  Backbone,
  $,
  _,
  App,
  SavingBehavior,
  DialogFormView,
  createEditLayoutTpl
) {
  'use strict';

  module.exports = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      cancel: '.js-cancel',
      confirm: '.js-confirm',
      orderByEmail: '.orderByEmail'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input' : 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm',
      'change @ui.orderByEmail': 'onChangeOrderByEmail'
    },

    regions: {
    },

    className: 'profile-create-edit',

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave'
    },

    fieldsToValidate: [
    ],

    initialize: function(options) {
      this.model = options.customerModel.clone();
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;

      if(!templateData.orderComment)
        templateData.orderComment = '';
      if(!templateData.website)
        templateData.website = '';
      return templateData;
    },

    onShow: function() {
      $.material.init();
    },

    onChangeOrderByEmail: function () {
      this.model.set('orderByEmail', this.ui.orderByEmail.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onConfirm: function() {
      if(this.validate(this.fieldsToValidate)) {
        this.model.save();
      }
    },

    onSave: function(model) {
      var modelJSON = model.toJSON();
      this.triggerMethod('saved');
      App.trigger('customer:header:rerender', modelJSON);
      this.hide();
    }
  });
});
